import { render, staticRenderFns } from "./ReceiveResults.vue?vue&type=template&id=ad351154&scoped=true"
import script from "./ReceiveResults.vue?vue&type=script&lang=js"
export * from "./ReceiveResults.vue?vue&type=script&lang=js"
import style0 from "./ReceiveResults.vue?vue&type=style&index=0&id=ad351154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad351154",
  null
  
)

export default component.exports